export const PLAN_GROUPS = [
  { title: 'プレミアプラン', indexes: [0, 1] },
  { title: 'ベーシックプラン', indexes: [2, 3] },
  { title: 'ミニマムプラン', indexes: [4, 5] },
  { title: 'ショートプラン', indexes: [6] },
  { title: '成功報酬プラン', indexes: [7] }
];
